const DEFAULT_PAGE_REQUEST_CONCURRENCY = 6
const MIN_PAGE_REQUEST_CONCURRENCY = 1
const MAX_PAGE_REQUEST_CONCURRENCY = 8

export const getDataReviewPageRequestConcurrency = (): number => {
	if (typeof window === "undefined") {
		return DEFAULT_PAGE_REQUEST_CONCURRENCY
	}

	const rawConcurrency = new URLSearchParams(window.location.search).get("dataReviewConcurrency")
	if (!rawConcurrency || !/^\d+$/.test(rawConcurrency)) {
		return DEFAULT_PAGE_REQUEST_CONCURRENCY
	}

	return Math.min(
		MAX_PAGE_REQUEST_CONCURRENCY,
		Math.max(MIN_PAGE_REQUEST_CONCURRENCY, Number(rawConcurrency)),
	)
}
